<script setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useUISettings } from 'dashboard/composables/useUISettings';

const route = useRoute();
const { uiSettings, updateUISettings } = useUISettings();

watch(
  () => route.params.agentId,
  newAgentId => {
    if (
      newAgentId &&
      newAgentId !== String(uiSettings.value.last_active_assistant_agent_id)
    ) {
      updateUISettings({
        last_active_assistant_agent_id: Number(newAgentId),
      });
    }
  }
);
</script>

<template>
  <div class="flex w-full h-full min-h-0">
    <section class="flex flex-1 h-full px-0 overflow-hidden bg-n-surface-1">
      <router-view />
    </section>
  </div>
</template>
